<div class="center">
    <h1>页面未找到</h1>
    <img src="{{'../../../assets/images/404.png' | absUrl}}" alt="404"/>
</div>
